
import SelectList from 'react-widgets/lib/SelectList'
import { DatePicker } from 'antd';
import moment from 'moment'

/*

import asyncValidate from './asyncValidate'
import {loadAddressDataDB as loadAccount } from '../../redux/svractions/svreviewActions'
*/
import {loadAddressDataSH as loadAccount } from '../../redux/svractions/shreviewActions'

import { reduxForm , handleSubmit, FieldArray,Field, startSubmit, formValueSelector} from 'redux-form'

//import { loadPdAction, loadPdMyReservatiionsAddressAction} from '../../actions'
import {SJTDFORM} from '../../constants'
import {SV_SOJ_ORCMOCK_ADDRESS} from '../../constants'
import { Radio } from 'antd'

///Users/sam_b2/Downloads/tm/svctest/frontend-quiz/app/css/svdreact.css
//import 'style-loader!../../css/svdreact.css'
import {  Link } from "react-router-dom"
import '../../css/svformwerror.css'
const React = require('react')
const _ = require('lodash')
const {connect}  = require("react-redux")


const svChange = (values, dispatch, props, valuesPrev)=>{

    console.log('sv form change')
  
    console.log(values)
  
  
  }
const svNotifySavePromise=(
    values
)=>{
            let url= `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuila`
            let data = {
                "id": "addLeft_step"

            }
            data = values
            //data =transformToBA(values)
            let postRq={
                method:'POST',
                headers:{
                    Accept:'application/json',
                    'Content-Type':'application/json'
                },
                body: JSON.stringify(data) 
            }


            return fetch(url, postRq).then((rs)=>{
                console.log('sv got rs promise')
                return rs.json()
            }).catch((e)=>{
                return new Promise.resolve(e)
            })
}

const svsubmit =(values)=>{
    let me = this
  console.log('sv submit callback')
  console.log(values)
/*

  Promise.all([svNotifySavePromise(values)]).then((ar)=>{
      console.log('sv got promise data')

      let rs= ar[0]
      console.log(rs)
        if(rs.data.value.payload.gene){
           // me.props.geneReceptorActivate(rs.data.value.payload.gene, rs.data.value.payload)
        }
   

  })
  */
  //this.props.handleSubmit(this.props.submit('SVClassifierForm'))
}

const renderField = ({
    input,
    label,
    type,
    meta: { asyncValidating, touched, error }
  }) => (
    
     
      
      <div className={asyncValidating ? 'async-validating' : ''}>
          
        <input className="form-control" {...input} type={type} placeholder={label} />
        {touched && error && <span className="sv-form-err" >{error}</span>}
      </div>
   
  )
  const renderFieldDup = ({
    input,
    label,
    type,
    meta: { asyncValidating, touched, error }
  }) => (
    
     
      
      <div className={asyncValidating ? 'async-validating' : ''}>
          {touched && error &&  <input className="sverr form-control" {...input} type={type} placeholder={label} /> }
          {touched && !error &&  <input className="svgreen form-control" {...input} type={type} placeholder={label} /> }
        <input className="form-control" {...input} type={type} placeholder={label} />
        {touched && error && <span className="sv-form-err" >{error}</span>}
      </div>
   
  )
  
const renderSelectList = ({ input, data }) => (
    <SelectList {...input} onBlur={() => input.onBlur()} data={data} />
  )
  const renderTravelSelectList = ({ input, data }) => (
    <SelectList {...input} onBlur={() => input.onBlur()} data={data} />
  )

const renderWillRbList = ({ input, data }) => (
    <SelectList {...input} onBlur={() => input.onBlur()} data={data} />
  )

  const renderBookingAgentType = ({input, data})=> (
      <SelectList {...input } onBlur={() =>input.onBlur()} data={data} />
  )
  
let dcountries = [{
    name:'United States Of America',
    value:'usa'

  },{
    name:'France',
    value:'France'
  },{

    name:'China',
    value:'China'
},{
    name:'Mexico',
    value:'Mexico'
  
  }]

let genes = [{
    name:'add_step',
    value:'add_step'

  },{
    name:'multiply_seq_step',
    value:'multiply_seq_step'
  },{

    name:'sq_step',
    value:'sq_step'
},{
    name:'sr_step',
    value:'sr_step'
  
  }]

  
  let validate =(formData)=>{
    console.log('sv--valudare fprmData')
      console.log(validate)
        const errors={}
        if(!formData){
            console.log('validate: sv formData null issue')
            console.log(errors)
            return errors
        }
        if(!formData.fname){
            errors.fname= 'Required'
        }
        if(!formData.lname){
            errors.lname= 'Required'
        }
        if(!formData.email){
            errors.email= 'Required'
        }
        if(!formData.address){
            errors.address= 'Required'
        }
        if(!formData.city){
            errors.city= 'Required'
        }
        if(!formData.zip){
            errors.zip= 'Required'
        }
       /*
        if(!formData.country){
            errors.country= 'Required'
        }
        if(!formData.phone){
            errors.phone= 'Required'
        }
        */
        /*sva
        if(!formData.card){
            errors.card= 'Required'
        }
        if(!formData.cvv){
            errors.cvv= 'Required'
        }
        if(!formData.mmexp){
            errors.mmexp= 'Required'
        }
        if(!formData.yyyyexp){
            errors.yyyyexp= 'Required'
        }
        if(!formData.country){
            errors.country= 'Required'
        }
        */
        return errors
    
    }
    
    let warn= (formData)=>{
        const o = {}
        if(!formData){
            console.log('sv gene null issue')
            return o
        }
        /*
        if(formData.lname <2){
            o.gene ='We expect gene to br more tham 5'
        }
        */
        return o
    }

    const data = {
        "id": 6,
        "addressId": 6,
        "customerId": 6,
        "name": "alen beta",
        "fname": "alen",
        "lname": "beta",
        "phone": "5121231234",
        "email": "alen11@br.com",
        "login": "alenb",
        "password": null,
        "otherDetails": "need pickup",
        "city": "san jose",
        "state": "ca",
        "country": "usa",
        "address": null,
        "zip": "95123",
        "isdcode": "3",
        "addressType": "B",
        "createdDate": null,
        "modifiedDate": null,
        "createdBy": null,
        "modifiedBy": null,

        "tstfname":"john",
        "tstlname":"mayes",
        "tstmanme":"ma",
        "tstprimaryddress":"12 jerry st alabany",
        "tstwillsnippet":"no property goes to carla",
        "tstemail":"alex@yahoo.com",
        "tstwilldate":null
    }

class SJPBPaymentDetailFormBus extends React.Component{
    

    constructor(props){
        super(props)
        let me = this
        this.svcadCurryCom = this.svcadCurryCom.bind(me)
        this.renderCad = this.renderCad.bind(me)
        this.loadGene = this.loadGene.bind(this)
        this.ddChange = this.ddChange.bind(this) 
        /*
        this.getAppDetails = this.getAppDetails.bind(this)
        */
        this.dcountryChange = this.dcountryChange.bind(this)
    }
    componentWillMount()	{
        console.log('sv--call PaymentData  should needs addressid action load to gtethe formvalues sjpbpdForm')
        const { custProfile, sj_data_address, sj_data_card} = this.props
         console.log('sv-- SJPaymentDetail  PaymentData custProfile  from SVWizard+')
      
        console.log(custProfile)
        console.log(sj_data_address)
         console.log('sv--SJPaymentDetail dcustProfile from  SVWizrd end')
         if( sj_data_address && (sj_data_address.email.length > 0)){
            console.log('sv--SJPaymentDetail dcustProfile from  SVWizrd calls load ')
            console.log(sj_data_address)
            this.props.load(sj_data_address)
         }
         /*
         if( custProfile && (custProfile.customerId > 0)){
            this.props.load(custProfile)
         }
         */
         /*
        const data = {
            "addressId": 6,
            "customerId": 6,
            "name": "alen beta",
            "fname": "alen",
            "lname": "beta",
            "phone": "5121231234",
            "email": "alen11@br.com",
            "login": "alenb",
            "password": null,
            "otherDetails": "need pickup",
            "city": "san jose",
            "state": "ca",
            "country": "usa",
            "address": null,
            "zipcode": "95123",
            "isdcode": "1",
            "addressType": "B",
            "createdDate": null,
            "modifiedDate": null,
            "createdBy": null,
            "modifiedBy": null
        }
       this.props.load(data)
       */
        
    console.log('sbv--sjourn id ****+++++++++++++++++++++++++++ we will use _doc as the space has details of sohourn as single flat indxex:')
    
    
      
   
			
			
	

	}
    /*
    

  
    getAppDetails(paramQSpaceId){
        // Previou step of wizard has alrady put the state  in Review get from thatfrom props and pas sjcpdData
       let newFormData= {
        "addressId": 6,
        "customerId": 6,
        "name": "alen beta",
        "fname": "alen",
        "lname": "beta",
        "phone": "5121231234",
        "email": "alen11@br.com",
        "login": "alenb",
        "password": null,
        "otherDetails": "need pickup",
        "city": "san jose",
        "state": "ca",
        "country": "usa",
        "address": null,
        "zipcode": "95123",
        "isdcode": "1",
        "addressType": "B",
        "createdDate": null,
        "modifiedDate": null,
        "createdBy": null,
        "modifiedBy": null
    }
        this.props.load(newFormData)
       
        
     }
     */
 loadGene(e){
        console.log(e)
    }

    dcountryChange(e){

        console.log(e)
        console.log('gene name:' +this.props.dcountry)

        let o = _.find(dcountries,{value:e.target.value})
        console.log(o)
        this.props.load({
            id:o.value,
             dcountry:o.name
        })

    }
    
    ddChange(e){
        
        console.log(e)
        console.log('gene name:' +this.props.gene)

        let o = _.findWhere(genes,{value:e.target.value})
        console.log(o)
        this.props.load({
            id:o.value,
             gene:o.name
        })
        //load geneBus Componnet initialValues and form will reinitalize

    }
    svcadCurryCom = (param1, ctxThis) => (o) => {
        console.log("*******svj22****curry** START")
        console.log(param1)

        console.log(ctxThis)

        console.log(o)
        const { input: { onChange, value } } = o
        console.log("*******svj22****redux vaalue**")
        console.log(value)
        let STARTDATE_ITN_TZAWARE_EST = "2025-11-25"

        let vob = null
        let vob_date = null
        let mo_ss = moment(STARTDATE_ITN_TZAWARE_EST, 'YYYY-MM-DD');
        let mofval = null
        let mofmom = null
        if(value && _.isString(value) && value.length <=1){
            vob_date = moment()
        } else if(value && _.isString(value) && value.length > 1){
            let d_s = value
            vob_date = moment(d_s)
            mofmom  = moment(d_s)
        } else if(value && _.isObject(value)){
            vob = value
            vob_date = value._d
            mofmom  = moment(vob_date)
        }else if (value == null){
            mofval = mo_ss
            mofmom = moment()

        }else{
            console.log('svJ30 ***bad valeue CAUSE ISSUE***')
            console.log(value)
             vob = value
             vob_date = value._d
             mofmom  = moment(vob_date)
        }
        console.log(vob_date)
         STARTDATE_ITN_TZAWARE_EST = "2025-11-25"

        
        /*
        if (value != null) {
            mofval = moment(vob_date)
            let mofval_str = mofval.format('YYYY-MM-DD')

            console.log("*******svj22****mofval_stre**")

            console.log(mofval_str)
            this.setState({'svdob':mofval_str})



           // let mom_value = !value ? mo_ss : mofval_str
           mofval = !value ? mo_ss : mofval_str
           mofmom = moment(mofval)
        } else {
            mofval = mo_ss
            mofmom = moment()
        }
        */

        let TIME_NO = false



        return (<DatePicker showTime={TIME_NO} onChange={onChange} value={mofmom} />)


    }
    renderCad({ input: { onChange, value }, showTime }){
        let param1 =  "1974-01-14"
        console.log('svj30*** FPD  value start')
        console.log(value)
        console.log('svj30*** FPD  value start')


        return (

            <Field 
            id="dateOfBirth"
            name="dateOfBirth"
                className="form-control"
                component={this.svcadCurryCom(param1, this)}
            />
        )


    }
    render(){

        console.log('sv... SVCDnaStepFormBus')
        const {renderCad} = this
        const { handleSubmit, pristine, error,reset, submitting } = this.props
        const { load, initialValues } = this.props
        //const { initialValues,load, handleSubmit,loadGeneTemplate,  pristine, reset, submitting, submit, startSubmit } = this.props 
       //we are copying all members from initialValues and senfint to props
       /* const {initialValues} = this.props
       

        */
        const {  isdcode, email} = this.props
        const {countryTypes, isdcodeTypes, genderTypes,stateTypes} = this.props.my_data_geo
        console.log( isdcode)
        console.log( email)
        console.log( isdcode)
        console.log(initialValues)
       // const { id, gene, email} = initialValues

        const me = this 
        //me.gene = gene

        console.log(this.props)

        return (
            <div>
             
            <form  onSubmit={handleSubmit}>
            <div className="rev-row">
                    <div className="card card--raised with-shadow">
                        <p className="right-sd-content"> <text> Will Details </text></p>
                        <div className="form-group">
                            <label htmlFor="exSuccessor"> Successor Executor or Co-Executors </label>
                            
                            <Field
                            
                                    id="exSuccessor"
                                    name="exSuccessor"
                                    type="text"
                                    placeholder="John"
                                    component={renderField}
                                    className="form-control"
                            />
                    </div>
                    <div className="form-group">
                            <label htmlFor="exName">  Executor or Co-Executors </label>
                            
                            <Field
                            
                                    id="exName"
                                    name="exName"
                                    type="text"
                                    placeholder="John"
                                    component={renderField}
                                    className="form-control"
                            />
                    </div>
                    <div className="form-group">
                            <label htmlFor="tstDisinheritedPersons"> Specify disinherited persons? </label>
                            
                            <Field
                            
                                    id="tstDisinheritedPersons"
                                    name="tstDisinheritedPersons"
                                    type="text"
                                    placeholder="John"
                                    component={renderField}
                                    className="form-control"
                            />
                    </div>
                    <div className="form-group">
                            <label htmlFor="tstFuneralWishes"> Funeral and Burial Wishes  </label>
                            
                            <Field
                            
                                    id="tstFuneralWishes"
                                    name="tstFuneralWishes"
                                    type="text"
                                    placeholder="John"
                                    component={renderField}
                                    className="form-control"
                            />
                    </div>
                        <div className="form-group">
                            <label htmlFor="tstWilltype">What type of Will you need ?</label>

                                <Field
                                name="tstWilltype"
                                component={renderWillRbList}
                                data={['StandardWill', 'PourOverWill']}
                                />
                        </div>
                        <div className="form-group">
                            <label htmlFor="tstMarried">Is testator Married ?</label>

                                <Field
                                name="tstMarried"
                                component={renderWillRbList}
                                data={['Yes', 'No']}
                                />
                        </div>
                        <div className="form-group">
                            <label htmlFor="isExbond">Will the Executor(s) server with bond ?</label>

                                <Field
                                name="isExbond"
                                component={renderWillRbList}
                                data={['Yes', 'No']}
                                />
                        </div>
                        <div className="form-group">
                            <label htmlFor="isExCompensated">Will the Executor(s) be Compensated ?</label>

                                <Field
                                name="isExCompensated"
                                component={renderWillRbList}
                                data={['Yes', 'No']}
                                />
                        </div>
                        <div className="form-group">
                            <label htmlFor="isCaregiverPet">Appoint a Caregiver for the Testator's pets ?</label>

                                <Field
                                name="isCaregiverPet"
                                component={renderWillRbList}
                                data={['Yes', 'No']}
                                />
                        </div>
                        <div className="form-group">
                            <label htmlFor="isDigitalAssetPlan">Include digital asset plan ?</label>

                                <Field
                                name="isDigitalAssetPlan"
                                component={renderWillRbList}
                                data={['Yes', 'No']}
                                />
                        </div>
                        <div className="form-group">
                            <label htmlFor="isOnlineNotary">Are you going to use an online notary service?</label>

                                <Field
                                name="isOnlineNotary"
                                component={renderWillRbList}
                                data={['Yes', 'No']}
                                />
                        </div>
                    </div>
            </div>
                {/* tsts start*/}
                <div className="rev-row">
                    <div className="card card--raised with-shadow">
                        <p className="right-sd-content"> <text> Testator Details </text></p>
                        <div className="form-group">
                            <label htmlFor="tstfname"> Testator First Name</label>
                            
                            <Field
                            
                                    id="tstfname"
                                    name="tstfname"
                                    type="text"
                                    placeholder="John"
                                    component={renderField}
                                    className="form-control"
                            />
                    </div>
                    <div className="form-group">
                            <label htmlFor="tstlname"> Testator Last Name</label>
                            
                            <Field
                            
                                    id="tstlname"
                                    name="tstlname"
                                    type="text"
                                    placeholder="John"
                                    component={renderField}
                                    className="form-control"
                            />
                    </div>
                    <div className="form-group">
                            <label htmlFor="tstmanme"> Testator Middle Name</label>
                            
                            <Field
                            
                                    id="tstmanme"
                                    name="tstmanme"
                                    type="text"
                                    placeholder="John"
                                    component={renderField}
                                    className="form-control"
                            />
                    </div>
                    <div className="form-group">
                                                <label htmlFor="tstwilldate"> Will Date</label>
                                                <Field
                                                        id="tstwilldate"
                                                        name="tstwilldate"
                                                        type="text"
                                                        placeholder="1979-05-18"
                                                        component={renderCad}
                                                        className="form-control"
                                                />
                                    
                    </div>
                    <div className="form-group">
                            <label htmlFor="tstprimaryddress"> Testator Primary Address</label>
                            
                            <Field
                            
                                    id="tstprimaryddress"
                                    name="tstprimaryddress"
                                    type="text"
                                    placeholder="12 jerry st alabany"
                                    component={renderField}
                                    className="form-control"
                            />
                    </div>
                    
                    <div className="form-group">
                            <label htmlFor="tstemail"> Testator Email</label>
                            
                            <Field
                            
                                    id="tstemail"
                                    name="tstemail"
                                    type="text"
                                    placeholder="John@yahoo.com"
                                    component={renderField}
                                    className="form-control"
                            />
                    </div>
                    </div>
                </div>
                 {/* tsts end*/}
            <div className="rev-row">
             <div className="card card--raised with-shadow">
                <p className="right-sd-content"> <text> User Details </text></p>
                    {/*testator start*/}
                   
                    {/*testator end*/}
                    <div className="form-group">
                            <label htmlFor="id"> ID</label>
                            
                                <Field
                            
                                id="id"
                                    name="id"
                                    type="text"
                                    placeholder="id"
                                    component="input"
                                    className="form-control"
                                />
                            

                        </div>
                    <div className="form-group">
                            <label htmlFor="fname"> First Name</label>
                            
                                <Field
                            
                                    id="fname"
                                    name="fname"
                                    type="text"
                                    placeholder="John"
                                    component={renderField}
                                    className="form-control"
                                />
                        </div>
                        <div className="form-group">
                            <label htmlFor="lname"> Last Name</label>
                            <Field
                                    id="lname"
                                    name="lname"
                                    type="text"
                                    placeholder="Glen"
                                    component={renderField}
                                    className="form-control"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="email"> Email Address</label>
                            <Field
                                    id="email"
                                    name="email"
                                    type="text"
                                    placeholder="john123@yahoo.com"
                                    component="input"
                                    className="form-control"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="address"> Address </label>
                            <Field
                                    id="address"
                                    name="address"
                                    type="text"
                                    placeholder="790 J St, Lincoln"
                                    component={renderField}
                                    className="form-control"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="city"> City</label>
                            <Field
                                    id="city"
                                    name="city"
                                    type="text"
                                    placeholder="Lincoln"
                                    component={renderField}
                                    className="form-control"
                            />
                        </div>
                       
                        <div className="form-group">
                            <label htmlFor="gene"> Zip Code</label>
                            <Field
                                    id="zip"
                                    name="zip"
                                    type="text"
                                    placeholder="95648"
                                    component={renderField}
                                    className="form-control"
                            />
                        </div>
                        <div className="form-group">
                                                <label htmlFor="dcountry" > Country</label>
                                                <Field  component="select" id="dcountry"   name="dcountry"  className="form-control" >
                                                
                                                    <option value="">Select Country A3</option>
                                                    {
                                        
                                                
                                        countryTypes.map(  (o, idx)=>(  <option value={o.value} key={o.name}>{o.name}</option>)
                                                    
                                                    
                                                    
                                                
                                                )}
        
                                                    </Field>
                        </div>
                        {/* 
                        <div class="form-group">
                        
                        <label htmlFor="dcountry">Country </label>
                        <Field id="dcountry"  name="dcountry" onChange={me.dcountryChange} component="select">

                            <option  value="">Select Country</option>
                            {
                                dcountries.map ((o, idx)=>{

                                    return ( <option  value={o.value}>{o.name}</option>)
                                })
                            }

                        </Field>

                        </div>
                        
                        */}
                        
                        <div className="form-group">
                                                <label htmlFor="isdcode" > ISD Code</label>
                                                <Field  component="select" id="isdcode"   name="isdcode"  className="form-control" >
                                                
                                                    <option value="">Select PhoneCalling /ISD Code</option>
                                                    {
                                        
                                                
                                        isdcodeTypes.map(  (o, idx)=>(  <option value={o.value} key={o.name}>{o.name}</option>)
                                                    
                                                    
                                                    
                                                
                                                )}
        
                                                    </Field>
                         </div>
                        {/* 
                        <div className="form-group">
                            <label htmlFor="isdcode"> ISD Code</label>
                            <Field
                                    id="isdcode"
                                    name="isdcode"
                                    type="text"
                                    placeholder="+1"
                                    component="input"
                                    className="form-control"
                            />
                        </div>
                        
                        */}
                        
                        <div className="form-group">
                            <label htmlFor="phone"> Phone</label>
                            <Field
                                    id="phone"
                                    name="phone"
                                    type="text"
                                    placeholder="916-645-6360"
                                    component={renderField}
                                    className="form-control"
                            />
                        </div>
                    
               

                {/*   
                <div className="form-group">
                   
                    <label className="svradio-item-label-bl">
                        <Field name="bookingAgentType" component="input" type="radio" value="self" />{' '}
                        Self
                    </label>
                    <label className="svradio-item-label-bl">
                        <Field name="bookingAgentType" component="input" type="radio" value="others" />{' '}
                        Others
                    </label>
    
                </div>
                */}
                {/* 
                <div className="form-group">
                    <label htmlFor="bookingAgentType">Who are you booking for?</label>

                        <Field
                        name="bookingAgentType"
                        component={renderSelectList}
                        data={['Self', 'Others']}
                        />
                </div>
                */}
               
                {/*  
                <div className="form-group">
                     <label htmlFor="specialRequests"> Special Requests</label>
                    <Field
                            id="specialRequests"
                            name="specialRequests"
                            type="text"
                            placeholder="Wheel chair and Senior Citizen"
                            component="textarea"
                            className="form-control"
                    />
                </div>
                <div className="form-group">
                     <label htmlFor="card">  Credit Card Number</label>
                    <Field
                            id="card"
                            name="card"
                            type="text"
                            placeholder="1234-1234--1234--1234"
                            component={renderField}
                            className="form-control"
                    />
                </div>
                <div className="form-group">
                     <label htmlFor="gene">  Card CVV/CVV2</label>
                    <Field
                            id="cvv"
                            name="cvv"
                            type="text"
                            placeholder="123"
                            component={renderField}
                            className="form-control"
                    />
                </div>
                <div className="form-group">
                     <label htmlFor="mmexp">  Card Expiration Date Month</label>
                    <Field
                            id="mmexp"
                            name="mmexp"
                            type="text"
                            placeholder="02"
                            component={renderField}
                            className="form-control"
                    />
                </div>
                <div className="form-group">
                     <label htmlFor="yyyyexp">  Card Expiration Date Year</label>
                    <Field
                            id="yyyyexp"
                            name="yyyyexp"
                            type="text"
                            placeholder="2028"
                            component={renderField}
                            className="form-control"
                    />
                </div>
                
                <div class="form-group">
                  
                  <label htmlFor="gene">BusSlot </label>
                  <Field id="gene"  name="gene" onChange={me.ddChange} component="select">

                    <option  value="">Select DNA</option>
                    {
                        genes.map ((o, idx)=>{

                            return ( <option  value={o.value}>{o.name}</option>)
                        })
                    }

                  </Field>

                </div>

                */}

               <div>
            </div>
            </div>
         </div>
            
            <div className="rev-row">
                    <div className="card card--raised with-shadow">
                        <p className="right-sd-content"> <text> Additional Travel Information </text></p>
                        <div className="form-group">
                            <label htmlFor="bookingAgentType">Who are you booking for?</label>

                                <Field
                                name="bookingAgentType"
                                component={renderBookingAgentType}
                                data={['selfTravel', 'others']}
                                />
                        </div>
                        <div>
                        <label htmlFor="radiogroupba">RG</label>
                        <Radio.Group name="radiogroupba" defaultValue={1}>
                            <Radio value={1}>A</Radio>
                            <Radio value={2}>B</Radio>
                            <Radio value={3}>C</Radio>
                            <Radio value={4}>D</Radio>
                         </Radio.Group>
                        </div>
                        <div className="form-group">
                            <label htmlFor="traveType">Business Travel ?</label>

                                <Field
                                name="traveType"
                                component={renderTravelSelectList}
                                data={['Business', 'Personal']}
                                />
                        </div>
                    </div>
            </div>
            
            <div className="rev-row">
              <div className="card card--raised with-shadow">
                 <p className="right-sd-content"> <text> Guest Details </text></p>

                 <div className="form-group">
                     <label htmlFor="gname"> Full Guest Name</label>
                    <Field
                            id="gname"
                            name="gname"
                            type="text"
                            placeholder="jenny"
                            component="input"
                            className="form-control"
                    />
                </div>
                <div className="form-group">
                     <label htmlFor="gemail">  Guest Email</label>
                    <Field
                            id="gemail"
                            name="gemail"
                            type="text"
                            placeholder="jenny@yahoo.com"
                            component="input"
                            className="form-control"
                    />
                </div>
            </div>
        
        <button type="submit" className="btn btn-success" disabled={pristine || error || submitting}>
               Next -  Payment Details
        </button>   
        <button type="button" className="btn btn-success" onClick={this.props.previousPage}>
          Previous - Space Details
        </button>
        <button type="button" onClick={() => load(data)}>
          Load Account
        </button>
        
        </div>
               

            
            </form>
         </div>
        )
    }

}

const sjpbpdForm = reduxForm({

    form:SJTDFORM,
    validate:validate,
    //asyncValidate: asyncValidate,
    warn:warn,
    //onSubmit:svsubmit,
    onChange:svChange,
    enableReinitialize:true,
    keepDirtyOnReinitialize:true

})(SJPBPaymentDetailFormBus)

const selector = formValueSelector(SJTDFORM)



let SJPBPaymentDetailFormBusCom =connect((state=>{
    //we are not using key nmae intiailValues rathre returning flat content ky/valu as sjcpdData
    //reducForm provideis built in load - we have tp provide our action here  then our form component can call load from props
    //we cannot mofifiy initial Valy=ues or statehere only in reducers
//we have action loadAddressData from reviewaction that modiefied sjcpdData in TaskReducer. the address data is stored in this form. we will add card data also in sjcpdData
    let plucked = state.movies
    console.log('sv***SJPaymentDetails taskreducers')
    console.log(plucked)
    let custProfile = state.reviewView.custProfile
    let sj_data_address = state.reviewView.sj_data_address
    let sj_data_card = state.reviewView.sj_data_card
    let o = {initialValues:plucked.sjcpdData ,"sj_data_card":sj_data_card,"sj_data_address":sj_data_address, "custProfile":custProfile}
    selector(state, 'id')
    console.log('sv info')
    console.log(o)
     
    //return plucked.sjcpdData
    return o
}),{
    //load:loadPdMyReservatiionsAddressAction,
    load:loadAccount,
    
    startSubmit:startSubmit
   
   // loadGeneTemplate:loadGeneTemplate

    
})(sjpbpdForm)





export default SJPBPaymentDetailFormBusCom